import { KOREAN } from '../../../assets/images';
import { Section, TableOfContent } from '../../../typings/interfaces';
// Korean
const KOSection: Section[] = [
  {
    name: '1: 참조 및 개요',
    subSections: [
      {
        name: '시작하기',
        page: 3,
      },
      {
        name: '목적 및 현장 가이드 응용',
        page: 4,
      },
      {
        name: '핵심 정의',
        page: 5,
      },
      {
        name: '통제 계층',
        page: 6,
      },
    ],
  },
  {
    name: '2: LIFESavers',
    subSections: [
      {
        name: '자동차 – 교통 안전',
        page: 9,
      },
      {
        name: '고공 작업',
        page: 12,
      },
      {
        name: '이동식 전동 장비(MPE)',
        page: 18,
      },
      {
        name: '잠금 표시/에너지 차단',
        page: 22,
      },
      {
        name: '전기 작업',
        page: 25,
      },
      {
        name: '밀폐 구역',
        page: 29,
      },
      {
        name: '벌크 원료/제품 취급 및 저장',
        page: 32,
      },
      {
        name: '철도 차량 안전',
        page: 37,
      },
      {
        name: '굴착 및 배수로 작업',
        page: 41,
      },
      {
        name: '인양작업',
        page: 45,
      },
      {
        name: '유해 물질',
        page: 49,
      },
      {
        name: '고온 작업',
        page: 52,
      },
    ],
  },
  {
    name: '3: 추가 자원 및 도구',
    subSections: [
      {
        name: '물 위 및 주변 작업',
        page: 56,
      },
      {
        name: '물체 낙하 또는 추락',
        page: 59,
      },
      {
        name: '대기/가스 테스트',
        page: 61,
      },
      {
        name: '화학물질 유해정보 전달 기준',
        page: 65,
      },
    ],
  },
  {
    name: '4: 카길 안전 관리 방침',
    subSections: [
      {
        name: '주요 용어',
        page: 70,
      },
      {
        name: '중상 및 사망 사고(SIF) 판단',
        page: 72,
      },
      {
        name: '잠재적으로 심각한 상해 및 사망 사고(SIFp) 분류',
        page: 73,
      },
      {
        name: 'SIF 자동 판단 기준표',
        page: 74,
      },
      {
        name: '불안전행동 방지를 위한 개인과 조직의 업무수행 이론(HOP)',
        page: 76,
      },
    ],
  },
];
const KOTableofContent: TableOfContent = {
  language: 'ko',
  sections: KOSection,
  label: '목차',
  pdfLink:
    'https://en-pdfs-life-on-focus.dev.cglcloud.in/Cargill Field Safety Guide KOREAN (ko_KR)_DIGITAL_CROPPED.pdf',
  hopPocket: 'HOP 포켓 가이드',
  hopPocketLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/HOP pocket guide content 2021-09-08_ko_KR.pdf',
  source: KOREAN,
};

export default KOTableofContent;
